import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { LeftOutlined } from '@ant-design/icons';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Card, Button, Input, message } from 'antd';
import CountDownBtn from '@/component/login/login_hlb/components/count-down-btn';
import NumberInput from '@/component/login/login_hlb/components/number-input';
import { validatePhone, validatePhoneRequired, newPasswordCheck, checkExistPhone } from '../validator';
import { forgetPassword } from '../utils';
import { sendSMSCode } from '@/tools/hlb';

import './recover.less'

const BackBtn = () => {
    const history = useHistory();

    return (
        <span className='back-btn' onClick={() => history.replace('/login')}>
            <LeftOutlined className='back-svg' />
            <span className='back-text'>返回</span>
        </span>
    );
};

const layout = {
    labelCol: { span: 0 },
    wrapperCol: { span: 24 }
};
const tailLayout = {
    wrapperCol: { offset: 0, span: 24 }
};

const Recover = (props) => {
    const { form } = props;
    const history = useHistory();

    const [isSend, setSend] = useState(false);
    const [disableSendBtn, setDisableSendBtn] = useState(true);
    const [btnLoading, setBtnLoading] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();
        form.validateFields(async (err, values) => {
            if (!err) {
                try {
                    setBtnLoading(true);
                    const params = {
                        phone: values.phone,
                        captcha: values.captcha,
                        newPassword: values.newPassword
                    };
                    const res = await forgetPassword(params)
                    if (res.status === 200) {
                        message.success('重置密码成功');
                        history.replace('/login');
                    }
                } finally {
                    setBtnLoading(false);
                }
            }
        });
    };
    const handleSendSMSCode = () => {
        return new Promise((resolve, reject) => {
            const phone = form.getFieldValue('phone');
            sendSMSCode(phone)
                .then(res => {
                    if (res.status === 200){
                        setSend(true);
                        setDisableSendBtn(true);
                        message.success('验证码已发送');
                        resolve();
                    } else {
                        reject('发送失败');
                    }
                });
        });
    };

    return (
        <div className='recover-card-container' style={{paddingRight: '36px'}}>
            <Card className='recover-card' title={<BackBtn />}>
                <div className='head'>
                    <h2 className='head-title'>重置密码</h2>
                </div>
                <div className="content">
                    <Form
                        {...layout}
                        onSubmit={handleSubmit}
                    >
                        <Form.Item>
                            {
                                form.getFieldDecorator('phone', {
                                    validateFirst: true,
                                    validateTrigger: !form.getFieldError('phone') ? 'onBlur' : 'onChange',
                                    rules: [
                                        validatePhoneRequired(),
                                        validatePhone(),
                                        {
                                            validator: checkExistPhone
                                        }
                                    ]
                                })(
                                    <NumberInput
                                        size="large"
                                        maxLength={11}
                                        placeholder="请输入手机号"
                                        allowClear
                                        onChange={(val) => {
                                            setDisableSendBtn(String(val).length !== 11);
                                        }}
                                    />
                                )
                            }
                        </Form.Item>

                        <Form.Item
                            extra={isSend ? '验证码已发送，2分钟内输入有效' : undefined}
                        >
                            <div className='phone-input'>
                                {
                                    form.getFieldDecorator('captcha', {
                                        validateFirst: true,
                                        validateTrigger: 'onBlur',
                                        rules: [
                                            { required: true, message: '请输入短信验证码' }
                                        ]
                                    })(
                                        <Input size="large" maxLength={6} placeholder="请输入短信验证码" />
                                    )
                                }

                                <CountDownBtn
                                    disabled={disableSendBtn}
                                    onCountStart={() => handleSendSMSCode()}
                                    onCountEnd={()=>{
                                        setDisableSendBtn(false);
                                    }}
                                />

                            </div>
                        </Form.Item>

                        <Form.Item>
                            {
                                form.getFieldDecorator('newPassword', {
                                    validateFirst: true,
                                    validateTrigger: 'onBlur',
                                    rules: [
                                        {
                                            required: true,
                                            message: '请设置新密码'
                                        },
                                        newPasswordCheck(),
                                        {
                                            validator(_, value) {
                                                if (value && form.getFieldValue('replicaPassword')) {
                                                    form.validateFields(['replicaPassword']);
                                                }
                                                return Promise.resolve();
                                            },
                                        }
                                    ],
                                })(
                                    <Input.Password
                                        size="large"
                                        maxLength={20}
                                        placeholder="设置新密码（6-20位，包含字母和数字）"
                                        visibilityToggle={Boolean(form.getFieldValue('newPassword'))}
                                        allowClear
                                    />
                                )
                            }
                        </Form.Item>

                        <Form.Item>
                            {
                                form.getFieldDecorator('replicaPassword', {
                                    validateFirst: true,
                                    validateTrigger: 'onBlur',
                                    rules: [
                                        {
                                            required: true,
                                            message: '请确认新密码'
                                        },
                                        {
                                            validator(_, value) {
                                                if (!value || form.getFieldValue('newPassword') === value) {
                                                    return Promise.resolve();
                                                }
                                                return Promise.reject(new Error('输入的两次密码不一致'));
                                            },
                                        },
                                    ],
                                })(
                                    <Input.Password
                                        size="large"
                                        maxLength={20}
                                        placeholder="确认新密码"
                                        visibilityToggle={Boolean(form.getFieldValue('replicaPassword'))}
                                        allowClear
                                    />
                                )
                            }
                        </Form.Item>
                        <Form.Item {...tailLayout} style={{ marginBottom: 0 }}>
                            <Button
                                loading={btnLoading}
                                type="primary"
                                size="large"
                                block
                                htmlType="submit"
                                className='submit-btn'
                            >
                                确认修改
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
            </Card>
        </div>
    )
};

const WrappedForm = Form.create()(Recover);
export default WrappedForm;
